<template lang="pug">
  #stock-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-freight" md-label="Грузы" v-bind:to="{ name: 'Freights'}")
      md-tab(id="tab-itineraries" md-label="Маршрутные листы" v-bind:to="{ name: 'Itineraries'}")
</template>

<script>
  export default {
    name: 'stock-menu',
    data() {
      return {
        title: '',
        activeTab: ''
      }
    },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
    computed: {},
    created() {
      this.activeTab = 'tab-' + this.$route.meta.tab;
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// stock-menu.vue?69c9d980